import { Box } from '@mui/material'
import React, { useRef, useEffect } from 'react'

interface Props {
  absolutes: number[]
  significantDigits?: number
  prefix?: string
  suffix?: string
}

const PercentileChartElementAxis: React.FC<Props> = ({
  absolutes,
  significantDigits,
  prefix = '',
  suffix = '',
}) => {
  const items = [
    null,
    useRef<Element>(),
    useRef<Element>(),
    useRef<Element>(),
    useRef<Element>(),
  ]

  useEffect(() => {
    items.forEach((item, i) => {
      if (item && item.current) {
        const ele = item?.current as HTMLElement
        const width = ele.offsetWidth
        if (i === items.length - 1) {
          ele.style.marginLeft = `-${width}px`
        } else {
          ele.style.marginLeft = `-${width / 2}px`
        }
      }
    })
  })

  const containerSx = {
    width: '100%',
    height: '55px',
    position: 'relative',
  }

  const itemSx = {
    position: 'absolute',
    bottom: '15px',
    lineHeight: '1',
    textAlign: 'center',
  }

  const toFixedDigits =
    significantDigits || significantDigits === 0 ? significantDigits : 2

  return (
    <Box sx={containerSx}>
      {absolutes.map((d, i) => (
        <Box
          key={`axis${i}`}
          ref={items[i]}
          sx={{ ...itemSx, left: `${i * 25}%` }}
        >
          <span>{`${i * 25}th`}</span>
          <br></br>
          <span>{`(${prefix}${d.toFixed(toFixedDigits)}${suffix})`}</span>
        </Box>
      ))}
    </Box>
  )
}

export default PercentileChartElementAxis
